<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @closed="closed"
             width="600px">
    <div style="margin: 20px 110px 0 80px">
      <el-form label-position="right" label-width="90px" :model="model" :rules="rules" ref="model" :key="isNew">
        <remote-form-item label="品牌名称" prop="brandId" class-name="Brand"></remote-form-item>
        <input-form-item label="车系名称" prop="name"></input-form-item>
        <status-form-item label="状态"></status-form-item>
        <textarea-form-item label="备注" prop="remarks"></textarea-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button v-if="isNew" type="primary" @click="add()">新 增</el-button>
      <el-button v-else-if="!readOnly" type="primary" @click="save()">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

  import InputFormItem from '@/components/form/InputFormItem'
  import StatusFormItem from '@/components/form/StatusFormItem'
  import TextareaFormItem from '@/components/form/TextareaFormItem'
  import RemoteFormItem from '@/components/form/RemoteFormItem'

  export default {
    name: 'EditModelDialog',
    components: {
      RemoteFormItem,
      TextareaFormItem,
      StatusFormItem,
      InputFormItem
    },
    props: {
      model: {
        type: Object,
        required: true
      },
      readOnly: Boolean
    },
    data () {
      return {
        rules: {
          brandId: [
            {
              required: true,
              message: '请选择品牌',
              trigger: 'change'
            }
          ],
          name: [
            {
              required: true,
              message: '请输入车系名称',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    methods: {
      closed () {
        if (!this.readOnly) {
          this.$refs.model.resetFields()
        }
      },
      add () {
        this.$refs.model.validate(valid => {
          if (!valid) return

          this.$store.dispatch('model/add', this.$_.cloneDeep(this.model)).then(() => {
            this.hide()
            this.$message.success('添加成功!')
          })
        })
      },
      save () {
        this.$refs.model.validate(valid => {
          if (!valid) return

          this.$store.dispatch('model/updateOne', this.$_.cloneDeep(this.model)).then(() => {
            this.hide()
          })
        })
      },
      cancel () {
        this.hide()
      },
      hide () {
        this.$emit('update:visible', false)
      }
    },
    computed: {
      isNew () {
        return !this.model.id
      },
      controlReadOnly () {
        return !this.isNew && this.readOnly
      },
      title () {
        if (this.isNew) return '新增车系'
        return this.readOnly ? '编辑车系' : '编辑车系'
      }
    }
  }
</script>
